import React from "react";
import NewButton from "../uiMerge/newButton";
import succesfulIcon from "../../assets/images/successNewIcon.svg";
import { NewModal } from "../uiMerge/newModal";
import copyIcon from "../../assets/svg/copyIconBold.svg";
import qrCodeIcon from "../../assets/svg/qrCodeIconNew.svg";
import { Popover } from "antd";
import CaptureButton from "../../modules/shared/CaptureButton";
import QrCodeModal from "./qrCodeModal";
import { formatAmountWithCommas } from "../../utils/formatAmount";
import { BrandName } from "../shared/BrandName";
// import { useNavigate } from "react-router";

type transactionSuccessModalProps = {
  isOpen: boolean;
  onClose: () => void;
  captionColor?: string;
  title?: string;
  isFreebie: boolean;
  amount?: string;
  icon: string;
  name: string | null | any;
  redeemedAt: string;
  redeemedTime: string;
  offerType: string | null | any;
  recipientType?: string | any;
  njoyCode?: string | null | any;
  partnerCode?: string | Array<string | null> | null;
  transactionReference?: string | null;
};

export function TransactionSuccessfulModal({
  recipientType = "Merchant",
  isOpen,
  onClose,
  title,
  isFreebie,
  amount,
  captionColor = "text-white",
  icon,
  name,
  redeemedAt,
  redeemedTime,
  njoyCode,
  partnerCode,
  offerType,
  transactionReference,
}: transactionSuccessModalProps) {
  let recipientTypeText: string | any;
  let captionText: string | any;

  const modalContentRef = React.useRef<HTMLDivElement>(null);
  const getPrimaryCode = React.useCallback(
    (value: string | Array<string | null> | null | undefined) => {
      if (Array.isArray(value)) {
        return value.find((code): code is string =>
          typeof code === "string" && code.trim().length > 0
        ) || "";
      }
      return typeof value === "string" ? value : "";
    },
    []
  );
  switch (offerType) {
    case "Referral":
      captionText =
        "You have successfully redeemed your offer and have been redirected to our partner's page.";
      break;

    case "Voucher":
      captionText = "You have successfully redeemed your offer.";
      break;

    case "Freebie":
      captionText = "You have successfully redeemed your offer.";
      break;

    case "Exclusive":
      captionText = "You have successfully redeemed your offer.";
      break;

    case "Giveaway":
      captionText = "You have successfully redeemed your offer.";
      break;

    case "Discount":
      captionText = "You have successfully redeemed your offer.";
      break;

    case "Cashback":
      captionText = "You have successfully redeemed your offer.";
      break;

    case "Successful":
      captionText =
        "Your transaction was successful and your balance has been updated.";
      break;

    default:
      captionText = "You have successfully redeemed your offer.";
      break;
  }

  switch (recipientType) {
    case "User":
      recipientTypeText = "Recipient";
      break;

    case "Merchant":
      recipientTypeText = "Merchant";
      break;

    default:
      recipientTypeText = "Merchant";
      break;
  }
  

  const handleCopyCode = async () => {
    const codeToCopy = getPrimaryCode(
      offerType === "Voucher" ? partnerCode : njoyCode
    );
    if (codeToCopy) {
      try {
        await navigator.clipboard.writeText(codeToCopy);
      } catch (err) {
        console.error("Failed to copy code:", err);
      }
    }
  };

  const [qrCode, setQrCode] = React.useState(false);

  const code = getPrimaryCode(
    offerType === "Voucher" ? partnerCode : njoyCode
  );

  const displayCode = typeof code === "string"
    ? code.length > 20
      ? `${code.toUpperCase().slice(0, 20)}...`
      : code.toUpperCase()
    : "";

  return (
    <NewModal
      isOpen={isOpen}
      onClose={onClose}
      roundedClass="rounded-t-2xl"
      colorClass="bg-black"
      position="end"
      showCloseButton={false}
      animationClass="grow-in"
    >
      <div className="py-4 px-[1rem]" ref={modalContentRef}>
        <div className="flex flex-col w-full items-center">
          <img src={succesfulIcon} alt="successful" width={85} height={85} />

          <h2
            className={
              "text-[24px] w-full text-center text-white font-bold mt-2 mb-1"
            }
          >
            {title}
          </h2>
        </div>

        <div>
          <div className="flex flex-col w-full justify-center items-center gap-2">
            <div className={" w-full text-white px-[4rem] text-center "}>
              {captionText}
            </div>
          </div>

          <hr className="bg-[#77777] mt-5 border w-full border-[#7777]" />
          <div className="flex justify-between items-center">
            <div className="flex justify-between items-center w-full">
              <div className="flex mt-3 items-center gap-2 w-[55%]">
                <div className="rounded-full">
                  <img
                    className="rounded-full object-cover w-[40px] h-[40px] border-solid border-[1px] border-[#D9D9D9]"
                    src={icon}
                    alt=""
                  />
                </div>
                <div className="flex flex-col ">
                  <p className="text-[16px] text-white font-semibold">{name}</p>

                  <p className="text-[12px] text-[#777] w-full">
                    {recipientTypeText}
                  </p>
                </div>
              </div>

              {
                offerType === "Voucher" ? null : 
                <div
                onClick={() => setQrCode(true)}
                className="flex flex-col mt-3 gap-[2px] items-center justify-center cursor-pointer">
                  <img
                  className=" object-cover rounded-[5px] bg-[#667085]"
                  src={qrCodeIcon}
                  alt=""
                  width={30}
                  height={30} />
                  
                  <p className="text-[10px] text-white">View</p>
                </div>
              }
            </div>

            <div className="flex flex-col mt-4">
              <p className="text-white text-[16px]">
                {isFreebie ? " " : formatAmountWithCommas(amount)}
              </p>
              <p className="text-[12px] text-[#777] flex justify-end w-full">
                {isFreebie ? "" : "Amount"}
              </p>
            </div>
          </div>

          <QrCodeModal 
          visible={qrCode} 
          onCancel={() => setQrCode(false)} 
          njoyCode={njoyCode} />

          {recipientType === "Merchant" ? (
            <div className="flex justify-between items-center mt-8">
              <p className="text-[15px] text-[#777]">
                {offerType === "Voucher" ? "Partner Code" : <><BrandName /> Code</>}
              </p>
              <div className="flex items-center gap-1 ">
                {/* * display the njoy code. In the second part it checks if the length is greater than 20 characters if it is, truncate it, and if it isnt,leave  */}
                <p className="text-[15px] font-black text-white">
                  {displayCode}
                </p>

                <div className="mb-1 cursor-pointer" onClick={handleCopyCode}>
                  <Popover
                    placement="topLeft"
                    arrowPointAtCenter
                    content="Copied!"
                    trigger="click"
                  >
                    <img crossOrigin="anonymous" src={copyIcon} alt="copy" />
                  </Popover>
                </div>
              </div>
            </div>
          ) : null}
          <hr className="bg-[#77777] mt-2 border w-full border-[#7777]" />
          <div className="flex justify-between items-center mt-2">
            <p className="text-[15px] text-[#777]">Date</p>
            <p className="text-[15px] text-white">{redeemedAt}</p>
          </div>

          <hr className="bg-[#77777] mt-2 border w-full border-[#7777]" />
          <div className="flex justify-between items-center mt-2">
            <p className="text-[15px] text-[#777]">Time</p>
            <p className="text-[15px] text-white">{redeemedTime}</p>
          </div>
          <div className="flex gap-4 items-center mb-3 mt-16">
            <CaptureButton
              targetRef={modalContentRef as React.RefObject<HTMLElement>}
              fileName="transaction-successful-receipt"
            />

            <NewButton fullWidth onClick={onClose}>
              Done
            </NewButton>
          </div>
        </div>
      </div>
    </NewModal>
  );
}

